<template>
  <div>
    <div v-if="planItems && planItems.length > 0">
      <v-sheet
        v-for="planItem in planItems"
        :key="planItem"
        class="grey lighten-4 my-2"
      >
        <v-row>
          <v-col cols="12" lg="2" xl="2">
            <span>{{ planItem.facilityName }}</span>
          </v-col>
          <v-col cols="12" lg="2" xl="2">
            <span v-if="planItem.quantity"
              >{{ planItem.quantity }} {{ planItem.unitName }}</span
            >
            <span v-else> -- </span>
          </v-col>
          <v-col cols="12" lg="2" xl="2">
            <div v-if="planItem.direction">
              {{ planItem.direction | capitalise }}
            </div>
          </v-col>
          <v-col cols="12" lg="2" xl="2">
            <span>{{ getTimeSpanStringForPlanItem(planItem) }}</span>
          </v-col>
          <v-col cols="12" lg="2" xl="2">
            <span>{{ planItem.timeSlots[0].locationName }}</span>
          </v-col>
          <v-col cols="12" lg="2" xl="2">
            <div>
              <v-icon
                small
                v-show="planItem.timeSlots[0].status === 'Completed'"
              >
                mdi-check-circle-outline
              </v-icon>
              <span>
                {{ planItem.timeSlots[0].status }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-sheet>
    </div>
    <v-alert v-else type="info" outlined color="primary">
      No Activities
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'VoyagePlanActivities',
  props: {
    planItems: {
      type: Array,
    },
  },
  methods: {
    getTimeSpanStringForPlanItem(item) {
      const { timeSlots } = item;
      if (timeSlots && timeSlots.length !== 0) {
        const { start, end } = timeSlots[0];
        const formattedStartDateTime = this.$options.filters.removeTAndSecondsAndFormatDate(start);
        const formattedEndTime = this.$options.filters.removeTAndDateAndSeconds(end);
        return `${formattedStartDateTime} - ${formattedEndTime}`;
      }
      return '--';
    },
  },
};
</script>

<style>
</style>
